<template>
    <div class="text-body-medium">
        <p>All ArupCompute functions can be called from Excel.</p>
        <p>
            The
            <a href="/docs/excel/" target="_blank" class="text-accent">
                documentation shows how to install the Excel plugin and how to
                use it.
            </a>
        </p>
        <p>
            The below snippet shows the formula name, and what inputs are
            required.
        </p>

        <CodeBox :text="formula" />

        <p>
            Some ArupCompute functions have a lot of inputs and outputs. To help
            set this up
            <a
                href="/docs/excel/how_to/calculation_templates"
                target="_blank"
                class="text-accent"
            >
                an automatic template can be inserted for any ArupCompute
                function.
            </a>
        </p>
    </div>
</template>
<script setup>
import { computed } from 'vue'
import CodeBox from './CodeBox.vue'

const props = defineProps(['calc'])

const formula = computed(() => {
    let names = []
    for (var input of props.calc.inputs) names.push(input.name)
    let hash = props.calc.api.split('_').at(-1)
    return (
        '=' +
        props.calc.fullname.replaceAll('+', '.') +
        '_' +
        hash +
        '(' +
        names.join(', ') +
        ')'
    )
})
</script>
